import { cva } from "class-variance-authority";

// SCSS-based slider variants using WeLoop design system classes
export const sliderVariants = cva(
  "wl-slider", // Base WeLoop slider class
  {
    variants: {
      variant: {
        default: "", // Default variant uses base wl-slider class
        primary: "wl-slider-primary",
        success: "wl-slider-success",
        warning: "wl-slider-warning",
        danger: "wl-slider-danger",
      },
      size: {
        default: "", // Default size is handled by wl-slider
        sm: "wl-slider-sm",
        lg: "wl-slider-lg",
      },
      showValue: {
        false: "", // No value display
        true: "wl-slider-with-value", // Show value on hover
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
      showValue: false,
    },
  }
);
